import type { DemoKey } from '../types';

export const ar: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'الرياضيات · الإحصاء',
  'app.title': 'الإحصاء',
  'panel.experiment': 'المشهد',
  'panel.params': 'المعاملات',

  'exp.survey-explorer.title': 'مستكشف الاستطلاع',
  'exp.survey-explorer.desc': 'اختر عمودًا؛ يختار العرض الملخّص المناسب.',
  'exp.distribution-sculptor.title': 'نحّات التوزيعات',
  'exp.distribution-sculptor.desc': 'اسحب النقاط وراقب استجابة الإحصاءات.',
  'exp.two-variable-lab.title': 'مختبر ثنائي المتغير',
  'exp.two-variable-lab.desc': 'تشتّت، انحدار، وسؤال السببية.',
  'exp.sampling-lab.title': 'مختبر المعاينة',
  'exp.sampling-lab.desc': 'كيف تحرّك التقنية والحجم متوسط العينة.',
  'exp.probability-diagrams.title': 'مخططات الاحتمال',
  'exp.probability-diagrams.desc': 'مشاهد فن وشجرة للحوادث المركّبة.',

  'type.qualitative-nominal.label': 'نوعي · اسمي',
  'type.qualitative-nominal.def': 'فئات بلا ترتيب جوهري.',
  'type.qualitative-ordinal.label': 'نوعي · ترتيبي',
  'type.qualitative-ordinal.def': 'فئات ذات ترتيب ذي معنى.',
  'type.qualitative-multi.label': 'نوعي · متعدد القيم',
  'type.qualitative-multi.def': 'لكل رصد قد توجد عدّة وسوم.',
  'type.quantitative-discrete.label': 'كمي · متقطّع',
  'type.quantitative-discrete.def': 'أعداد بخطوات ثابتة.',
  'type.quantitative-continuous.label': 'كمي · مستمر',
  'type.quantitative-continuous.def': 'أعداد مقيسة على مقياس متّصل.',

  'column.name.label': 'اسم الطالب',
  'column.height_cm.label': 'الطول',
  'column.shoe_size_eu.label': 'مقاس الحذاء (EU)',
  'column.study_hours.label': 'ساعات الدراسة / أسبوع',
  'column.test_score.label': 'درجة الاختبار',
  'column.sports_played.label': 'الرياضات الممارسة',
  'column.eye_color.label': 'لون العينين',
  'column.commute_min.label': 'المسافة اليومية',
  'column.grade_year.label': 'الصف',
  'column.homework_effort.label': 'مجهود الواجب',
  'column.ice-cream-sales.label': 'مبيعات الآيس كريم',
  'column.drownings.label': 'حالات الغرق',
  'column.month.label': 'الشهر',
  'column.storks.label': 'اللقالق',
  'column.births.label': 'المواليد',
  'column.country_area_km2.label': 'مساحة الدولة',
  'column.sleep_hours.label': 'ساعات النوم',
  'column.reaction_ms.label': 'زمن الاستجابة',

  'dataset.master-survey.label': 'استطلاع الصف',
  'dataset.master-survey.desc': '30 طالبًا محاكى.',
  'dataset.spurious-ice-cream-vs-drownings.label': 'مبيعات الآيس كريم مقابل الغرق',
  'dataset.spurious-ice-cream-vs-drownings.desc':
    'كلاهما يصعد وينزل مع الموسم. الغرق لا يسبب مبيعات الآيس كريم.',
  'dataset.spurious-storks-vs-births.label': 'اللقالق مقابل المواليد',
  'dataset.spurious-storks-vs-births.desc':
    'الدول الأكبر فيها لقالق أكثر ومواليد أكثر. الطيور ليست السبب.',
  'dataset.real-sleep-vs-reaction-time.label': 'النوم مقابل زمن الاستجابة',
  'dataset.real-sleep-vs-reaction-time.desc':
    'نوم أكثر، استجابة أسرع. ارتباط سالب حقيقي — وآلية معقولة.',

  'tag.football.label': 'كرة القدم',
  'tag.basketball.label': 'كرة السلة',
  'tag.volleyball.label': 'الكرة الطائرة',
  'tag.swimming.label': 'السباحة',
  'tag.none.label': 'لا شيء',

  'population.gaussian.label': 'منحنى الجرس',
  'population.right-skewed.label': 'ملتوٍ يمينًا',
  'population.bimodal.label': 'ثنائي القمّة (بطبقات)',
  'population.uniform.label': 'منتظم',

  'venn.dice-even-or-prime.label': 'النرد: زوجي أو أولي',
  'venn.class-sports-2set.label': 'الرياضات (مجموعتان)',
  'venn.class-sports-3set.label': 'الرياضات (ثلاث مجموعات)',
  'venn.custom.label': 'مخصّص',

  'tree.draw-without-replacement.label': 'سحب بلا إعادة',
  'tree.custom.label': 'مخصّص',
  'tree.coin.heads': 'ص',
  'tree.coin.tails': 'ك',
  'tree.draw.start': 'كيس: 2 حمراء، 3 زرقاء',
  'tree.draw.red': 'أحمر',
  'tree.draw.blue': 'أزرق',
  'tree.custom.start': 'البداية',
  'tree.custom.A': 'A',
  'tree.custom.B': 'B',

  'card.histogram': 'المدرج التكراري',
  'card.cumulative': 'التكرار المتراكم',
  'card.box': 'مخطط الصندوق',
  'card.summary': 'ملخّص خمسة أعداد',
  'card.bar': 'مخطط الأعمدة',
  'card.mode': 'المنوال',
  'card.tag-frequency': 'تكرار الوسوم',
  'card.mode-tag': 'الوسم الأكثر',
  'card.empty-no-order': 'غير منطبق',
  'card.empty-multi': 'غير منطبق',
  'card.numberline': 'خط الأعداد',
  'card.scatter': 'تشتّت',
  'card.description': 'ما يجري',
  'card.population': 'المجتمع',
  'card.sampling-distribution': 'متوسطات العيّنات',
  'card.venn': 'فن',
  'card.tree': 'شجرة',
  'card.probabilities': 'احتمالات',

  'param.dataset.label': 'مجموعة البيانات',
  'param.column.label': 'العمود',
  'param.bins.label': 'الفئات',
  'param.shape.label': 'الشكل الابتدائي',
  'param.show-mean.label': 'إظهار المتوسط',
  'param.show-median.label': 'إظهار الوسيط',
  'param.x-col.label': 'العمود X',
  'param.y-col.label': 'العمود Y',
  'param.show-regression.label': 'خط الانحدار',
  'param.show-residuals.label': 'البواقي',
  'param.show-confounder.label': 'إظهار المتغيّر المربك',
  'param.population.label': 'المجتمع',
  'param.technique.label': 'الأسلوب',
  'param.sample-size.label': 'حجم العيّنة',
  'param.stratum.label': 'الطبقة',
  'param.bias.label': 'الانحياز',
  'param.mode.label': 'الوضع',
  'param.preset.label': 'إعداد جاهز',
  'param.universe.label': 'حجم الكون',
  'param.show-prob.label': 'إظهار الاحتمالات',
  'param.treat-as-numeric.label': 'اعتبار رقمي',

  'stat.count': 'العدد',
  'stat.mean': 'المتوسط',
  'stat.median': 'الوسيط',
  'stat.range': 'المدى',
  'stat.q1': 'Q1',
  'stat.q3': 'Q3',
  'stat.iqr': 'IQR',
  'stat.outliers': 'القيم المتطرّفة',
  'stat.r': 'r بيرسون',
  'stat.r2': 'r²',
  'stat.slope': 'الميل',
  'stat.intercept': 'الجزء المقطوع',
  'stat.n': 'n',
  'stat.population-mean': 'المتوسط الحقيقي',
  'stat.latest-sample-mean': 'متوسط العيّنة',
  'stat.sample-mean-spread': 'الانحراف المعياري لمتوسط العيّنة',
  'stat.sample-count': 'العيّنات المسحوبة',
  'outlier.upper': 'متطرّفات علوية',
  'outlier.lower': 'متطرّفات سفلية',

  'region.A': 'A',
  'region.B': 'B',

  'btn.resample': 'إعادة المعاينة',
  'btn.run-100': 'سحب 100 عيّنة',
  'btn.stop': 'إيقاف',
  'btn.clear-history': 'مسح السجل',

  'explainer.no-order': 'بلا ترتيب → لا تكرار متراكم ولا صندوق.',
  'explainer.multi-no-iqr': 'متعدد القيم → الأرباع / IQR غير معرّفين.',
  'message.no-data': 'لا توجد بيانات.',
  'message.needs-quartiles': 'يلزم ≥4 نقاط للأرباع.',
  'message.x-zero-variance': 'تباين X صفر — لا خط ملائم.',
  'message.n-too-small': 'n صغيرة جدًا.',
  'message.stratum-clamp': 'الطبقة فيها صفوف أقل من المطلوب — استُخدمت كلها.',
  'message.siblings-sum-to-one': 'مجموع الأبناء يجب أن يساوي 1.',
};
